import React from "react";
import { Layers } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetAccountModulesQuery } from "fond/api";
import { InfoOutlined } from "fond/form/fields/PermissionField/PermissionsField.styles";
import { useCurrentProject } from "fond/hooks/useCurrentProject";
import { Overlays } from "fond/map/Overlays";
import { accountModuleCheck, Actions } from "fond/utils/permissions";
import { BlockSpinner } from "fond/widgets";
import NonIdealState from "fond/widgets/NonIdealState";

import { ITabProps } from "./factory";

/**
 * Main widget component that determines the content rendered within the tab
 */
export const Widget: React.FC<ITabProps> = ({ node }: ITabProps) => {
  const project = useCurrentProject();
  const { data: accountModules, isLoading: isLoadingAccountModules } = useGetAccountModulesQuery(project?.Account.ID ?? skipToken);
  const isEnabled = accountModuleCheck(accountModules, Actions.CUSTOM_OVERLAYS);

  if (isLoadingAccountModules) {
    return (
      <Box display="flex" height="100%">
        <BlockSpinner />
      </Box>
    );
  }

  if (!isEnabled) {
    return <NonIdealState size="small" icon={<InfoOutlined />} description={<>This feature is not currently available.</>} />;
  }

  return <Overlays />;
};

/**
 * Icon component used by the iconFactory to generate the tabs left icon adornment.
 */
export const Icon: React.FC<ITabProps> = ({ node }: ITabProps) => (
  <Tooltip title="Overlays">
    <Layers />
  </Tooltip>
);
